<template>
  <div class="content-wrapper">
    <h2 class="page-titles">Swag Store</h2>
    <NoGiftAvailable
      v-if="
        !isLoading &&
          remainingShipments === 0 &&
          availableAdditionalOrders === 0
      "
    />
    <OrderStats />
    <InventoryStats />
    <TrendingGifts />
    <OrderChart />
    <!--    Feature not created -->
    <!--    <div class="cards">-->
    <!--      <BlogCard />-->
    <!--      <PricingPlansCard />-->
    <!--    </div>-->
    <!--    Feature not created -->
  </div>
</template>

<script>
import { layouts, storeModules } from '../helpers'
import store from '../store'
import { mapState } from 'vuex'

export default {
  name: 'ReportDashboard',
  data() {
    return {
      isLoading: true
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (
      store.state.team.team.teamModuleNames.includes(storeModules.swag_store)
    ) {
      next()
    } else if (
      store.state.team.team.teamModuleNames.includes(storeModules.project)
    ) {
      next({ name: 'Projects' })
    }
  },
  components: {
    OrderStats: () => import('@/components/Report/OrderStats'),
    InventoryStats: () => import('@/components/Report/InventoryStats'),
    OrderChart: () => import('@/components/Report/OrderChart'),
    TrendingGifts: () => import('@/components/Report/TrendingGifts'),
    // BlogCard: () => import('@/components/Universal/BlogCard'),
    // PricingPlansCard: () => import('@/components/Universal/PricingPlansCard'),
    NoGiftAvailable: () =>
      import('@/components/Notification/SwagStore/NoGiftsAvailable.vue')
  },
  created() {
    Promise.all([
      this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD),
      this.$store.dispatch('profile/getProfile', { reloadProfile: false }),
      this.$store.dispatch('report/avarageShipments')
    ]).then(() => {
      this.isLoading = false
    })
  },
  computed: {
    ...mapState({
      remainingShipments: state => state.report.remainingShipments,
      availableAdditionalOrders: state =>
        state.team.team.availableAdditionalOrders
    }),
    userName() {
      return Object.entries(this.user).length
        ? this.user.firstName
        : this.user.email
    },
    user() {
      return this.$store.getters['profile/user']
    },
    teamName() {
      return this.$store.getters['team/teamName']
    }
  }
}
</script>

<style scoped lang="scss">
// todo: push these into global.scss;
@import '@/global.scss';

.stats-grid {
  padding-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.stats-grid > * {
  width: 49%;
}

.cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin: 1rem 0;
  gap: 2rem;
}

@media (max-width: 575.98px) {
  .stats {
    width: 100%;
    flex: 0 1 auto;
  }
}

@media (max-width: 854px) {
  .cards {
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  .cards {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

@media (max-width: 854px) {
  .cards {
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  .cards {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .stats {
    width: 100%;
    flex: 0 1 auto;
  }
}
</style>
